import { createAsyncThunk } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { softDeleteThreadV1ForV2 } from '../api/threadsApi';
export const copilotV1DeleteFromV2Thread = createAsyncThunk('threads/copilotV1DeleteFromV2Thread', async threadId => {
  try {
    await softDeleteThreadV1ForV2({
      threadId
    });
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      extra: {
        component: 'copilotV1DeleteFromV2Thread',
        action: 'copilotV1DeleteFromV2Thread',
        copilotVersion: '2',
        threadId
      }
    });
  }
});